import React from "react";

const AjindaPrint = ({
  Datee,
  Namemowakell,
  Sefamo,
  Mahkamaa,
  Dategalasa,
  Qarar,
  NameKhesm,
  SefaKhesm,
  TypeDawa,
  NumberDawa,
  Numbercircle,
  Typecircle,
  Nots,
}) => {
  return (
    <>
      <div id="printt">
      <h3 className="text-center m-3">بيانات الأجندة</h3>

        <p>
          <span>التاريخ: </span>
          {new Date(Datee).toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>اسم الموكل: </span>
          {Namemowakell}
        </p>
        <p>
          <span>صفة الموكل: </span>
          {Sefamo}
        </p>
        <p>
          <span>اسم الخصم: </span>
          {NameKhesm}
        </p>
        <p>
          <span>صفة الخصم: </span>
          {SefaKhesm}
        </p>
        <p>
          <span>نوع الدعوى: </span>
          {TypeDawa}
        </p>
        <p>
          <span>رقم الدعوى: </span>
          {NumberDawa}
        </p>
        <div className="d-flex ">
          <p style={{ marginLeft: "10px" }}>
            <span>اسم المحكمة: </span>
            {Mahkamaa}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>نوع الدائرة: </span>
            {Typecircle}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>رقم الدائرة: </span>
            {Numbercircle}
          </p>
        </div>
        <p>
          <span>القرار: </span>
          {Qarar}
        </p>
        <p>
          <span>تاريخ الجلسة اللاحقة: </span>
          {new Date(Dategalasa).toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>ملاحظات: </span>
          {Nots}
        </p>
      </div>
    </>
  );
};

export default AjindaPrint;
